import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { paymentApis } from '../api/paymentApi';
import type { ApiResponse } from '@/shared/types/api';

interface UseStripeConnectCallbackProps {
  code: string;
  state: string;
  options?: UseQueryOptions<ApiResponse<null>>; // <- allow passing options
}

export const useStripeConnectCallback = ({
  code,
  state,
  options,
}: UseStripeConnectCallbackProps) => {
  return useQuery<ApiResponse<null>>({
    queryKey: ['stripe', 'connect', 'callback', code, state],
    queryFn: () => paymentApis.stripeConnectCallback(code, state),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!code && !!state,
    ...options, // merge options like onSuccess/onError
  });
};
